'use strict';

import 'moment';
import {gsap} from 'gsap';
import select2 from 'select2';

let bp = {
    "maxMobile": 767,
    "minDesktop": 1025,
    "longDesktop": 875
}


let debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

let delay = function (label,callback){
    if(typeof window.delayed_methods=="undefined"){window.delayed_methods={};}

    delayed_methods[label]=Date.now();

    var t=delayed_methods[label];

    setTimeout(function(){ if(delayed_methods[label]!=t){return;}else{  callback();}}, 500);
};

let isFieldEmpty = function (el) {
    return el.val() == '' || el.val() == null;
}

let $dobDay = $('#DobDay'),
    $dobMonth = $('#DobMonth'),
    $dobYear = $('#DobYear');

let isDobEmpty = function() {
    return $dobDay.val() == '' || $dobMonth.val() == '' || $dobYear.val() == '';
};

let isValidDob = function(){

    let $currentDate = $('#currentDate'),
         currYear = $currentDate.data('year'),
         currMonth = $currentDate.data('month'),
         currDay = $currentDate.data('day'),
         minYearAllowed = currYear - 150;

    if (isDobEmpty()) {
        return false;
    } else {
        let dateCheck = moment($dobYear.val() + '-' + $dobMonth.val() + '-' + $dobDay.val(), 'YYYY-MM-DD');
        let currentDate = moment(currYear + '-' + currMonth + '-' + currDay, 'YYYY-MM-DD');

        if (!dateCheck.isValid()) {
            return false;
        } else if (currentDate < dateCheck) {
            return false;
        } else if (!isDecimal($dobMonth.val())) {
            return false;
        } else if($dobYear.val() < minYearAllowed) {
            return false;
        } else {
            return true;
        }
    }
};

let autofocusDob = function(){
    //autofocu on DOB inputs
    $('.dob').on('keyup', '.floating-input', function (e) {
        let $this = $(this),
            $parent = $this.parent(),
            $grandParent = $parent.parent(),
            maxLength = $this.attr('maxlength');

        if (!(e.keyCode == 16 || e.keyCode == 9))
        {
            if ($this.val().length == maxLength) {
                $grandParent.next().find('.floating-input').focus();
            }
        }

    });
};

let isFieldSame = function($el1, $el2) {
    return $el1.val().trim() == $el2.val().trim();
};

let isValidEmail = function(email) {
    let isValid = false;
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    isValid = re.test(email);
    if(isValid) {
        let invalidEmailAddresses = $("#InvalidEmailAddresses").val().toLowerCase().split(",");
        if(invalidEmailAddresses.indexOf(email.toLowerCase()) > -1) {
            isValid = false;
        }
    }
    return isValid;
};

//zero not allowed
let isValidDecimal = function(value) {

    let re = /^(?!^0*$)(?!^0*\.0*$)^\d{1,2}(\.\d{1,2})?$/;
    return re.test(value);
};

let isValidDetails = function($requiredInputs){
    let _isInvalid = [];

    $requiredInputs.each( function(){

        let $this = $(this);

        if(isFieldEmpty($this)){

            displayInputError($this, false);

            _isInvalid.push(0);
        }
    })

    if (_isInvalid.length > 0)
        return false;
    else
        return true;
};

//zero allowed
let isDecimal = function(value) {

    let re = /^\d*\.?\d*$/;
    return re.test(value);
};

//additional validation for input numbers
let alloPositiveOnly = function(event){
    return (event.which == 189) ? true : false;
};

//used in conjuction to attribute step
let upToTwoDecimal = function(value){
    let re = /^\d*(\.\d{0,2})?$/;
    return re.test(value);
};

let decodeResponse = function (encodedValue) {
    var txt = document.createElement('textarea');

    txt.innerHTML = encodedValue;

    return txt.value;
};

let getErrorMessage = function(serverError) {
    let _messages = serverError.responseJSON.Errors;
    let errors = [];
    for(let i = 0, l = _messages.length; i < l; i++){
        errors.push(_messages[i].Message);
    }
    return errors.join();
};

// Display error message if ajax call fails
let displayErrors = function(serverError, errorBoxClass ){
    let error = serverError.responseJSON;
    if (error === undefined) {
      error = JSON.parse(serverError.responseText);
    }
    console.log(error);
        let errType = error.ErrorType,
        errCode = error.StatusCode,
        errMessages = '',
        _messages = error.Errors;

    if(errType == "Security"){
        window.location = '/';
    }

    if(error.hasOwnProperty('Errors')) {
        for( let i = 0, l = _messages.length; i < l; i++){
            errMessages += '<p>' + _messages[i].Message; + '</p>';
        }
    }
    else
    {
        errMessages += '<p>' + error + '</p>';
    }

    errorBoxClass.html(errMessages);

    errorBoxClass.slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false
    });
};

// Display error message for input validation
let displayInputError = function($input, isValid) {

    if (!isValid) {
        $input
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
    } else {
        $input
            .parent().removeClass('incomplete')
            .find('.error').slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
    }
};

let goToNextSection = function (el) {
    let $header = $('.header'),
        isAnim = true;

    $(el).fadeIn({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            gsap.to(window, {duration: 1,
                scrollTo: {
                    y: el,
                    offsetY: 75,
                    ease: "expo.inOut"
                },
                onComplete: function () {
                    isAnim = false;
                }
            });
        }
    });
};

// Toggle progress bar
let toggleProgressBar = function(sectionInd) {
    let $multiStepsNav = $('.multi-steps-nav');

    $multiStepsNav.find('li:nth-child(' + sectionInd + ')')
        .removeClass('active')
        .next().addClass('current-page__link active');
};

// better way ro round decimals than toFixed()
let round = function(input, decimals){
     return Number(Math.round(input+'e'+decimals)+'e-'+decimals);
};

let adjustFooterOnWindowResize = function() {
    var $window = $(window),
        $main = $('#main'),
        $footer = $('.footer');

    $window.on('resize scroll', debounce(function () {
        if (($window.outerHeight() - $footer.outerHeight()) > ($main.outerHeight() + parseInt($main.css('margin-top')))) {
            $footer.addClass('fixed');
        } else {
            $footer.removeClass('fixed');
        }

    }, 250)).trigger('resize');
};

let initiateAutoCompleteSuburb = function($autoCompleteElement, $suburbElement, $postCodeElement, $stateElement) {
    if($autoCompleteElement.length == 0) return;

    $autoCompleteElement.on('select2:select', function (e) {
        let selection = e.params.data;
        $suburbElement.val(selection.suburb);
        $suburbElement.data("api-value", selection.suburb);
        $postCodeElement.val(selection.postcode);
        $postCodeElement.data("api-value", selection.postcode);
        $stateElement.val(selection.state);
        $stateElement.data("api-value", selection.state);
        // $autoCompleteElement.val(selection.text);
        $autoCompleteElement.data("api-value", selection.text);
        $stateElement.trigger("change");
    });

    $autoCompleteElement.select2({
        width: "100%",
        allowClear: true,
        ajax: {
          url: function(params){
              return getAustPostApiUrl(params.term);
          },
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              query: params.term, // search term
              page: params.page
            };
          },
          processResults: function (data, params) {
            // parse the results into the format expected by Select2
            // since we are using custom formatting functions we do not need to
            // alter the remote JSON data, except to indicate that infinite
            // scrolling can beused
            params.page = params.page || 1;
            
            return {
              results: data,
              pagination: {
                more: (params.page * 30) < data.length
              }
            };
          },
          cache: false
        },
        placeholder: 'Search for a suburb or postcode',
        minimumInputLength: 2,
        templateResult: formatAddress,
        templateSelection: formatAddressSelected
      });      
    
    let existingData = $autoCompleteElement.data("api-value");
    if(existingData != "") {
        // Create a DOM Option and pre-select by default
        var newOption = new Option(existingData, Date.now().toString(), true, true);
        // Append it to the select
        $autoCompleteElement.append(newOption);
    }

    let formatAddress = function (address, container) {
        return address.text;
    }

    let formatAddressSelected = function(address, container) {
        return address.text;
    }

    // const options = {
    //     method: 'GET'
    //   };
    // const autoCompleteJS = new autoComplete({
    //     selector: () => {return $autoCompleteElement.get(0)},
    //     placeHolder: "Suburb or Postcode *",
    //     data: {
    //         src: async (query) => {
    //             try {
    //                 let qs = getAustPostApiUrl($stateElement.val(), query);
    //                 // Fetch Data from external Source
    //                 const source = await fetch(qs, options);
    //                 // Data is array of `Objects` | `Strings`
    //                 const data = await source.json();
    //                 return data;
    //             } catch (error) {
    //                 return error;
    //             }
    //         },
    //         // Data 'Object' key to be searched
    //         keys: ["text"],
    //         cache: false,
    //         filter: (list) => {
    //             const results = list.filter((item) => {
    //                 const inputValue = autoCompleteJS.input.value.toLowerCase();
    //                 const itemValue = item.value.text.toLowerCase();
            
    //                 if (itemValue.startsWith(inputValue)) {
    //                     return item.value;
    //                 }
    //             });
            
    //             return results;
    //         }
    //     },
    //     threshold: 3,
    //     resultsList: {
    //         element: (list, data) => {
    //             if (!data.results.length) {
    //                 // Create "No Results" message element
    //                 const message = document.createElement("div");
    //                 // Add class to the created element
    //                 message.setAttribute("class", "no_result");
    //                 // Add message text content
    //                 message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
    //                 // Append message element to the results list
    //                 list.prepend(message);
    //             }
    //         },
    //         noResults: true,
    //         maxResults: 100
    //     },
    //     resultItem: {
    //         highlight: true
    //     },
    //     events: {
    //         input: {
    //             // keydown: (event) => {
    //             //     if($autoCompleteElement.data("original-value") != $autoCompleteElement.data("api-value")) {
    //             //         $autoCompleteElement.data("api-value", "");
    //             //     }
    //             // },
    //             blur : (event) => {
    //                 if($autoCompleteElement.data("api-value") != $autoCompleteElement.val()) {
    //                     $autoCompleteElement.val($autoCompleteElement.val().trim());
    //                     if($autoCompleteElement.val().trim() != "") {
    //                         $autoCompleteElement.val($autoCompleteElement.data("original-value"));
    //                     }
    //                 }
    //             },
    //             selection: (event) => {
    //                 const selection = event.detail.selection.value;
    //                 $suburbElement.val(selection.suburb);
    //                 $suburbElement.data("api-value", selection.suburb);
    //                 $postCodeElement.val(selection.postcode);
    //                 $postCodeElement.data("api-value", selection.postcode);
    //                 $stateElement.val(selection.state);
    //                 $stateElement.data("api-value", selection.state);
    //                 $autoCompleteElement.val(selection.text);
    //                 $autoCompleteElement.data("api-value", selection.text);
    //             }
    //         }
    //     }
    // });
}

let getAustPostApiKey = function(){
    return $("#AustPostApiKey").val();
}
let getAustPostApiUrl = function(state, query){
    let url = `/api/suburbpostcode?state=`;//?query=${query}`; //https://digitalapi.auspost.com.au/postcode/search.json?q=|query|&state=|state|&excludePostBoxFlag=true
    return url;
}

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend(jQuery.easing, {
    def: 'easeOutQuad',
    easeOutExpo: function (x, t, b, c, d) {
        return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    },
    easeInOutExpo: function (x, t, b, c, d) {
        if (t == 0) {
            return b;
        }

        if (t == d) {
            return b + c;
        }

        if ((t /= d / 2) < 1) {
            return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
        }

        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
});

export {
    alloPositiveOnly,
    bp,
    debounce,
    isFieldEmpty,
    isValidEmail,
    isFieldSame,
    isDobEmpty,
    isValidDecimal,
    isDecimal,
    upToTwoDecimal,
    displayErrors,
    isValidDob,
    autofocusDob,
    isValidDetails,
    delay,
    displayInputError,
    goToNextSection,
    toggleProgressBar,
    decodeResponse,
    round,
    getErrorMessage,
    adjustFooterOnWindowResize,
    initiateAutoCompleteSuburb,
    getAustPostApiKey,
    getAustPostApiUrl
};
